@if (ProposalRequest) {
  <div class="container-fluid">
    <div class="row row-padding">
      <div class="col">
        <label class="fs-28">Bid Request Documents</label>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col">
            <label class="fs-22">Bid Request Information</label>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <label>ID:</label>
          </div>
          <div class="col">
            <label>{{ ProposalRequest.id }}</label>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <label>Name:</label>
          </div>
          <div class="col">
            <label>{{ ProposalRequest.name }}</label>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <label>Site Name:</label>
          </div>
          <div class="col">
            <label>{{ ProposalRequest.Site?.legalName }}</label>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="row">
          <div class="col">
            <label class="fs-22">Bid Request Documents</label>
          </div>
        </div>
        @for (
          ProposalRequestFile of ProposalRequestFiles;
          track ProposalRequestFile
        ) {
          <div class="row">
            <div class="col">
              <label
                class="underline cursor-select"
                (click)="proposalRequestFileSelected(ProposalRequestFile.File)"
                >{{ ProposalRequestFile.File?.filename }}</label
              >
            </div>
          </div>
        } @empty {
          <div class="row">
            <div class="col text-muted">No documents attached.</div>
          </div>
        }
      </div>
      <div class="col">
        <div class="row">
          <div class="col">
            <label class="fs-22">Bid Documents</label>
          </div>
        </div>
        @for (
          ProposalRequestVendor of ProposalRequestVendors;
          track ProposalRequestVendor
        ) {
          <div class="row">
            <div class="col">
              <label class="fw-normal"
                >{{ ProposalRequestVendor.legalName }}:</label
              >
            </div>
            <div class="col">
              @for (
                ProposalFile of ProposalRequestVendor.Proposal?.ProposalFiles ||
                  [];
                track ProposalFile
              ) {
                <div class="row">
                  <label
                    class="underline cursor-select"
                    (click)="proposalFileSelected(ProposalFile.File)"
                    >{{ ProposalFile.File?.filename }}</label
                  >
                </div>
              } @empty {
                <div class="row text-muted">No documents submitted.</div>
              }
            </div>
          </div>
        } @empty {
          <div class="row">
            <div class="col text-muted">No vendors invited.</div>
          </div>
        }
      </div>
    </div>
  </div>
}
